import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { sessionQuery } from '#admin/features/auth/queries.ts'
import { hasPlatformScope } from '#admin/features/platform/api.ts'
import { ModulesEditor } from '#admin/features/platform/tenants/modules-editor.tsx'
import { tenantQuery } from '#admin/features/platform/tenants/queries.ts'

/** `/platform/tenants/$tenantId/modules` — what this edition holds, module by module. */
export const Route = createFileRoute('/_authenticated/platform/tenants/$tenantId/modules')({
  staticData: { crumb: 'Modules' },
  component: ModulesTab,
})

function ModulesTab() {
  const { tenantId } = Route.useParams()
  const { data: tenant } = useSuspenseQuery(tenantQuery(tenantId))
  const { data: session } = useSuspenseQuery(sessionQuery())

  return (
    <ModulesEditor
      // Keyed by the tenant, so moving between editions does not carry one's unsaved edit into
      // the next.
      key={tenant.id}
      tenant={tenant}
      canManage={hasPlatformScope(session, 'platform:tenants.manage')}
    />
  )
}
